module.exports = __webpack_public_path__ + "img/wxOpen.2cec609c.png";